import mapKnownValues from "../../utils/mapKnownValues";
import MailingDetails from "./mailingDetails";

export class MailingDetailsWithItemQuantity extends MailingDetails {
  standeeQuantity = 0;
  brochureQuantity = 0;
  posterQuantity = 0;
  cakeQuantity = 0;
  _originalData = "";

  constructor(params: Partial<MailingDetailsWithItemQuantity>) {
    super(params);
    mapKnownValues(this, params);
    if (!params?._originalData) {
      this._originalData = JSON.stringify({
        ...this,
        _originalData: undefined,
      });
    }
  }

  get hasChanged() {
    return (
      JSON.stringify({
        ...this,
        _originalData: undefined,
        uid: undefined,
      }) !== this._originalData
    );
  }

  toJSONForAPI() {
    return JSON.stringify({
      ...this,
      uid: undefined,
      _originalData: undefined,
    });
  }
}
